// src/modules/app-views/omnichannel/pages/Init/modals/CloseContextModal/Step1.jsx
// *******************************************************************************
// CLOSE CONTEXT MODAL - STEP 1
// *******************************************************************************

// *******************************************************************************
// IMPORTS
// *******************************************************************************
import { Alert, Form, Input } from 'antd';
import SimpleSelect from 'components/SimpleComponents/SimpleSelect';
import translateX from 'utils/translateX';

// *******************************************************************************
// CONSTANTS
// *******************************************************************************
const CLOSE_REASONS = [
  { value: 'resolved', label: 'close_reason_resolved' },
  { value: 'doubt', label: 'close_reason_doubt' },
  { value: 'mistake', label: 'close_reason_mistake' },
  { value: 'no_response', label: 'close_reason_no_response' },
  { value: 'other', label: 'close_reason_other' },
];

// *******************************************************************************
// STEP CONTENT COMPONENT
// *******************************************************************************
const CloseContextStep1Content = () => {
  return (
    <>
      <Alert
        title={translateX('close_context')}
        description={translateX('close_context_description')}
        type="warning"
        showIcon
        style={{ marginBottom: 16 }}
      />

      <SimpleSelect
        name="reason"
        label={translateX('close_reason')}
        required
        options={CLOSE_REASONS.map(r => ({
          value: r.value,
          label: translateX(r.label),
        }))}
      />

      <Form.Item name="description" label={translateX('description')}>
        <Input.TextArea
          rows={3}
          placeholder={translateX('description')}
          maxLength={500}
          showCount
        />
      </Form.Item>
    </>
  );
};

// *******************************************************************************
// STEP CONFIGURATION
// *******************************************************************************
const closeContextStep = () => ({
  stepTitle: 'close_context',
  stepTooltip: 'close_context',
  content: () => <CloseContextStep1Content />,
  validationFields: ['reason'],
});

// *******************************************************************************
// EXPORT
// *******************************************************************************
export default closeContextStep;
